import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const industries = [
  { titleKey: 'industry_ecommerce', descKey: 'industry_ecommerce_desc', icon: 'ri-shopping-cart-2-line' },
  { titleKey: 'industry_services', descKey: 'industry_services_desc', icon: 'ri-briefcase-4-line' },
  { titleKey: 'industry_restaurants', descKey: 'industry_restaurants_desc', icon: 'ri-restaurant-2-line' },
  { titleKey: 'industry_construction', descKey: 'industry_construction_desc', icon: 'ri-building-2-line' },
  { titleKey: 'industry_healthcare', descKey: 'industry_healthcare_desc', icon: 'ri-heart-pulse-line' },
  { titleKey: 'industry_realestate', descKey: 'industry_realestate_desc', icon: 'ri-home-office-line' },
  { titleKey: 'industry_technology', descKey: 'industry_technology_desc', icon: 'ri-computer-line' },
  { titleKey: 'industry_retail', descKey: 'industry_retail_desc', icon: 'ri-store-line' },
  { titleKey: 'industry_transport', descKey: 'industry_transport_desc', icon: 'ri-truck-line' },
  { titleKey: 'industry_beauty', descKey: 'industry_beauty_desc', icon: 'ri-scissors-cut-line' },
  { titleKey: 'industry_education', descKey: 'industry_education_desc', icon: 'ri-book-open-line' },
  { titleKey: 'industry_auto', descKey: 'industry_auto_desc', icon: 'ri-car-wash-line' },
];

export default function IndustriesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#F8F3FB] px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-widest mb-3">
            Industries We Serve
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('industries_title')}
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            {t('industries_subtitle')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {industries.map(({ titleKey, descKey, icon }) => (
            <div
              key={titleKey}
              className="group bg-white rounded-xl p-5 border border-[#E9D9F2] hover:border-[#DBB6EE] hover:-translate-y-1 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#F8F3FB] group-hover:bg-[#E9D9F2] transition-colors mb-4">
                <i className={`${icon} text-[#4F2D63] text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">{t(titleKey)}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{t(descKey)}</p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="text-center mt-10">
          <p className="text-sm text-gray-500 mb-4">Don&apos;t see your industry?</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border-2 border-[#4F2D63] text-[#4F2D63] font-semibold text-sm hover:bg-[#F8F3FB] transition-colors cursor-pointer whitespace-nowrap"
          >
            Contact us to find out if you qualify
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
